// extracted by mini-css-extract-plugin
export var baseButton = "_vr-0";
export var controlsArrowKeys = "_vr-1";
export var controlsResetButton = "_vr-2";
export var lightGameButton = "_vr-4 _vr-0";
export var playAgainButton = "_vr-5 _vr-0";
export var startGameButton = "_vr-3 _vr-0";